import styled from "styled-components/macro";

export const Wrapper = styled.div`
  position: relative;
  cursor: pointer;
`;

export const LinkText = styled.span`
  overflow: hidden;
  color: var(--Active-100);
  text-overflow: ellipsis;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.014px;
  text-decoration-line: underline;

  &.link-text-pointer {
    cursor: pointer;
    text-underline-offset: 1px;
    text-underline-position: from-font;
  }
`;

export const DropdownMenu = styled.div`
  position: absolute;
  z-index: 9999;
  min-width: 130px;
  padding: 4px;
  border-radius: 8px;
  background: #fff;
  background: color(display-p3 1 1 1);
  box-shadow:
    0 110px 31px 0 color(display-p3 0 0 0 / 0),
    0 70px 28px 0 color(display-p3 0 0 0 / 0.01),
    0 40px 24px 0 color(display-p3 0 0 0 / 0.05),
    0 18px 18px 0 color(display-p3 0 0 0 / 0.09),
    0 4px 10px 0 color(display-p3 0 0 0 / 0.1);
`;

export const DropdownItem = styled.div`
  padding: 8px 14px;
  font-size: 14px;
  cursor: pointer;
  border-radius: 4px;
  transition: background 0.2s ease;
  display: flex;
  align-items: center;
  gap: 6px;
  color: var(--Neutral-100);
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: -0.012px;

  &:hover {
    background: var(
      --Neutral-2,
      linear-gradient(
        0deg,
        color(display-p3 0.1216 0.1216 0.1216 / 0.02) 0%,
        color(display-p3 0.1216 0.1216 0.1216 / 0.02) 100%
      ),
      color(display-p3 1 1 1)
    );
  }
`;
